import React, { useEffect } from 'react';
import { Grid } from '@ellucian/react-design-system/core';
import SolutionCard from './SolutionCard';
import type { Solution } from '../../types';
import { trackSolutionListView } from '../../utils/analytics';

interface Props {
  solutions: Solution[];
}

const SolutionGrid: React.FC<Props> = ({ solutions }) => {
  // Track when solutions list is viewed
  useEffect(() => {
    if (solutions && solutions.length > 0) {
      trackSolutionListView(solutions, 'solution_grid', 'marketplace');
    }
  }, [solutions]);

  if (!solutions || solutions.length === 0) {
    return (
      <div style={{ minHeight: '300px' }}>
        {/* Empty state handled by parent component */}
      </div>
    );
  }

  return (
  <Grid
      container
      spacing={2}
      sx={{
        mb: '80px',
        pb: '40px',
        width: '100%',
        boxSizing: 'border-box',
        px: { xs: 2, sm: 2, md: 0 },
        // Ensure grid items can shrink on small screens and avoid horizontal overflow
        '& .MuiGrid-item': {
          minWidth: 0,
        },
        // Prevent accidental horizontal overflow caused by Grid spacing negative margins
        overflowX: { xs: 'hidden', md: 'visible' },
        // Center container and constrain max width on small screens to account for page padding
        maxWidth: { xs: 'calc(100% - 32px)', sm: 'calc(100% - 32px)', md: '100%' },
        mx: 'auto',
      }}
      className="solutions-grid"
      style={{ fontFamily: '"Proxima Nova", Montserrat, Aptos, Roboto' }}
    >
      {solutions.map((solution) => (
        <Grid 
          item 
          key={solution.id || solution.storefrontIntegrationId} 
          xs={12} 
          sm={6} 
          md={4} 
          lg={4}
          xl={3}
        >
          <SolutionCard solution={solution} />
        </Grid>
      ))}
    </Grid>
  );
};

export default SolutionGrid;
